<nav aria-label="breadcrumb">
    <ol class="breadcrumb bg-transparent pl-0">
        <li class="breadcrumb-item"  *ngIf="showHome"><a routerLink="/" routerLinkActive="active">Home</a></li>
        <li *ngFor="let breadcrumb of breadcrumbs" class="breadcrumb-item">
            <a [routerLink]="[breadcrumb.url, breadcrumb.params]" *ngIf="breadcrumb.url?.length > 0">{{ breadcrumb.label }}</a>
            <span *ngIf="!breadcrumb.url">{{ breadcrumb.label }}</span>
        </li>
    </ol>
</nav>